import styled from 'styled-components';
import { exFont } from '../../shared/typography';
import { StepPage } from '../YourMarksStep/style';

// Results header, chips, tabs and modals (tplA 1237–1259, 1715–1733).
export const ResultsPage = styled(StepPage)`
  max-width: 1000px;
  padding: 28px 24px 44px;
  gap: 14px;
`;

export const Header = styled.div`
  min-height: 40px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.h2`
  ${exFont(700, 'xxl')}
  margin: 0;
`;

export const Grow = styled.span`
  flex: 1 1 auto;
`;

export const HeaderButton = styled.button`
  ${exFont(600, 'm')}
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 9px 16px;
  border: 1px solid ${({ $accent }) => ($accent ? 'var(--ex-purple)' : 'var(--ex-line-strong)')};
  border-radius: var(--ex-radius-pill);
  background: var(--ex-surface);
  color: ${({ $accent }) => ($accent ? 'var(--ex-purple)' : 'var(--ex-ink-strong)')};
  cursor: pointer;
  &:hover {
    background: var(--ex-surface-2);
  }
  &:focus-visible {
    outline: 2px solid var(--ex-purple);
    outline-offset: 2px;
  }
`;

export const MenuWrap = styled.div`
  position: relative;
`;

export const Menu = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 30;
  min-width: 260px;
  padding: 6px;
  background: var(--ex-surface);
  border: 1px solid var(--ex-line);
  border-radius: var(--ex-radius-card);
  box-shadow: var(--ex-shadow-3);
`;

export const MenuItem = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  padding: 10px 12px;
  text-align: left;
  border: none;
  border-radius: var(--ex-radius-item);
  background: transparent;
  cursor: pointer;
  &:hover,
  &:focus-visible {
    background: var(--ex-surface-tint);
    outline: none;
  }
`;

export const MenuTitle = styled.span`
  ${exFont(600, 's')}
  color: var(--ex-ink);
`;

export const MenuSub = styled.span`
  ${exFont(400, 'xs')}
  color: var(--ex-ink-2);
`;

export const Popover = styled(Menu)`
  left: 0;
  right: auto;
  width: 340px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PopoverTitle = styled.p`
  ${exFont(600, 'm')}
  margin: 0;
`;

export const PopoverText = styled.p`
  ${exFont(400, 's')}
  margin: 0;
  color: var(--ex-ink-2);
  line-height: 1.45;
`;

export const SampleLine = styled.div`
  ${exFont(400, 's')}
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid var(--ex-line);
`;

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const ScopeChip = styled.button`
  ${exFont(600, 's')}
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 7px 14px;
  border-radius: var(--ex-radius-pill);
  border: 1px solid
    ${({ $active }) => ($active ? 'var(--ex-purple)' : 'var(--ex-line-strong)')};
  background: ${({ $active }) =>
    $active ? 'var(--ex-purple)' : 'var(--ex-surface)'};
  color: ${({ $active }) =>
    $active ? 'var(--white)' : 'var(--ex-ink-strong)'};
  cursor: pointer;
`;

export const ChipSub = styled.span`
  ${exFont(500, 'xs')}
  opacity: 0.85;
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  border-bottom: 1px solid var(--ex-line);
`;

export const Tab = styled.button`
  ${exFont(600, 'm')}
  padding: 10px 16px;
  border: none;
  border-bottom: 2px solid
    ${({ $active }) => ($active ? 'var(--ex-purple)' : 'transparent')};
  background: none;
  color: ${({ $active }) => ($active ? 'var(--ex-purple)' : 'var(--ex-ink-2)')};
  cursor: pointer;
  margin-bottom: -1px;
`;

export const RulesPanel = styled.div`
  ${exFont(400, 's')}
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 16px;
  border-radius: var(--ex-radius-item);
  background: var(--ex-surface-tint);
  color: var(--ex-ink-2);
  b {
    color: var(--ex-ink);
  }
`;

export const ModalCard = styled.div`
  width: min(760px, calc(100vw - 32px));
  max-height: calc(100vh - 64px);
  overflow: auto;
  background: var(--white);
  border-radius: 16px;
  box-shadow: var(--ex-shadow-modal);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* focused as a container by useModalFocus; its controls keep their rings */
  &:focus {
    outline: none;
  }
`;

export const ModalHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const ModalTitle = styled.p`
  ${exFont(600, 'xl')}
  margin: 0;
`;

export const ModalSub = styled.p`
  ${exFont(400, 's')}
  margin: 2px 0 0;
  color: var(--ex-ink-2);
`;

export const QuestionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 0;
  border-bottom: 1px solid var(--ex-line);
  p {
    margin: 0;
  }
`;

export const QuestionMeta = styled.div`
  ${exFont(600, 's')}
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const QuestionBody = styled.p`
  ${exFont(400, 'm')}
  color: var(--ex-ink);
  line-height: 1.5;
`;

export const RubricTable = styled.table`
  ${exFont(400, 's')}
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    padding: 8px;
    border: 1px solid var(--ex-line);
    vertical-align: top;
    text-align: left;
  }
  th {
    ${exFont(600, 's')}
    background: var(--ex-surface-2);
  }
`;

export const BannerLine = styled.div`
  ${exFont(500, 's')}
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: var(--ex-radius-item);
  color: var(--ex-info-ink);
  background: var(--ex-info-bg);
`;
